import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

/** Propriétés personnalisées des fiches contact, définies par l'entreprise. */
export type ContactPropertyKind = 'text' | 'number' | 'date' | 'checkbox' | 'url'

export interface ContactPropertyDef {
  id: number
  label: string
  kind: ContactPropertyKind
  position: number
}

const CLE = ['contact-properties']

export function useContactProperties() {
  return useQuery({
    queryKey: CLE,
    queryFn: async () => {
      const { data } = await api.get<{ properties: ContactPropertyDef[] }>('/api/contact-properties/')
      return data.properties
    },
    staleTime: 60_000,
  })
}

export function useCreateContactProperty() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: { label: string; kind: ContactPropertyKind }) => {
      const { data } = await api.post<ContactPropertyDef>('/api/contact-properties/', input)
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CLE }),
  })
}

export function useDeleteContactProperty() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await api.delete(`/api/contact-properties/${id}/`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CLE })
      // Les valeurs disparaissent des fiches : on les relit.
      queryClient.invalidateQueries({ queryKey: ['contact'] })
    },
  })
}
